import { AlertTriangle, FileText, CheckCheck } from 'lucide-react';
import { toast } from 'sonner';
import { gapsOf, fillGaps } from '../lib/importGaps';
import { importPdf } from '../lib/importPdf';
import { NI } from '../lib/i18nNetImport';

// imported network: values missing in the source block the calculation until filled in or suggestions confirmed
export function ImportGaps({ project, updateProject }) {
  const L = NI[document.documentElement.lang] || NI.en, g = gapsOf(project), log = project.importLog;
  if (!g.n && !log) return null;
  return (
    <div className={g.n ? 'aq-dry ni-gaps' : 'ni-gaps'} data-testid="imp-gaps">
      {g.n > 0 && <>
        <b><AlertTriangle size={14} /> {L.gapT}</b>
        <ul>{Object.entries(g.c).filter(([, v]) => v).map(([k, v]) => <li key={k} data-testid={`imp-gap-${k}`}>{L[`gap_${k}`].replace('{n}', v)}</li>)}</ul>
        <small>{L.gapHint}</small>
        <button className="btn btn-outline btn-sm" data-testid="imp-gaps-fill" onClick={() => { updateProject(fillGaps); toast.success(L.gapDone); }}><CheckCheck size={14} /> {L.gapFill}</button>
      </>}
      {log && <button className="btn btn-outline btn-sm" data-testid="imp-log-pdf" onClick={() => { try { importPdf(log, g); } catch (e) { toast.error(String(e?.message || e)); } }}><FileText size={14} /> {L.logBtn}</button>}
    </div>
  );
}
